import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import { toggleForgotPasswordModal, sendForgotPasswordEmail } from '../actions/forgot-password-actions';
import forgotPasswordConstants from '../constants/forgot-password-constants';
import { validate } from '../validators/forgot-password-validators';
import DefaultInput from '../../../shared/default-input/components/default-input';
import constants from '../../../../common/constants';
import Button from '../../../shared/button/components/button';
import ModalHeader from '../../../shared/modal-header/components/modal-header';

import '../styles/forgot-password-modal.css';

class ForgotPasswordModal extends Component {
  closeModal() {
    const { toggleForgotPasswordModal } = this.props;

    toggleForgotPasswordModal(false);
  }

  handleFormSubmit(values) {
    const { sendForgotPasswordEmail } = this.props;

    sendForgotPasswordEmail(values.email);
  }

  render() {
    const { showForgotPasswordModal, handleSubmit, httpInProgress } = this.props;

    return (
      <Modal visible={showForgotPasswordModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="forgot-password-modal-container">
          <ModalHeader title={'FORGOT_PASSWORD_MODAL.TITLE'} subtitle={'FORGOT_PASSWORD_MODAL.SUBTITLE'} onClick={() => this.closeModal()} />
          <form onSubmit={handleSubmit(values => this.handleFormSubmit(values))} className="forgot-password-modal-container__form" noValidate>
            <div className="row">
              <div className="col-md-12">
                <Field name={forgotPasswordConstants.fields.email} label={'REGISTER.EMAIL'} disabled={httpInProgress} component={DefaultInput} type={constants.input_types.email} />
              </div>
              <div className="col-md-12">
                <Button label={'FORGOT_PASSWORD_MODAL.SUBMIT_BTN'} customClass={'affiliate-btn-red m-t-20'} disabled={httpInProgress} type={'submit'} />
              </div>
            </div>
          </form>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  showForgotPasswordModal: state.forgotPasswordReducer.showForgotPasswordModal,
});

const mapDispatchToProps = dispatch => ({
  toggleForgotPasswordModal: show => {
    dispatch(toggleForgotPasswordModal(show));
  },
  sendForgotPasswordEmail: email => {
    dispatch(sendForgotPasswordEmail(email));
  },
});

ForgotPasswordModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

ForgotPasswordModal = reduxForm({
  form: forgotPasswordConstants.form_name,
  validate,
})(ForgotPasswordModal);

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordModal);



// WEBPACK FOOTER //
// ./src/app/main/forgot-password/components/forgot-password-modal.js